import { ActionIcon, Badge, Button, Checkbox, Grid, Group, Input, Loader, LoadingOverlay, Menu, Modal, MultiSelect, Paper, Tabs, Text } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import moment from 'moment';
import React from 'react';
import { FaAsterisk, FaBell, FaCalendar, FaCheck, FaEllipsisV, FaGlobe, FaMinusSquare, FaPaperPlane, FaPlusCircle, FaWrench } from 'react-icons/fa';
import InputField, { InputFieldTypes } from '../components/input_field';
import InfiniteLoading from '../components/infinite_loading';
import ThemePaper from '../components/theme_paper';
import { GET_ALL_THEMES, GET_FILTERS_OPTIONS } from '../services/themes';
import { groupBy } from '../utility/util';
import { useAuth } from '../contexts/auth.context';
import { Buffer } from 'buffer';
  
export default function Home(){
    const { userData } = useAuth();

    const [homefiltersLS] = React.useState(localStorage.getItem("@dmoc/homeFilters"));
    const [homefilters] = React.useState(homefiltersLS ? JSON.parse(homefiltersLS) : {});
    const [page, setPage] = React.useState<{[key:string]: number}>({});
    const [macroFilter, setMacroFilter] = React.useState<string>((homefilters.withInteractions && homefilters.keywords) ? '2' : '1');
    const [ending, setEnding] = React.useState<{[key:string]: boolean}>({});
    const [loading, setLoading] = React.useState<{[key:string]: boolean}>({});
    const [loadingPage, setLoadingPage] = React.useState<{[key:string]: boolean}>({});
    const [data, setData] = React.useState<any>({});
    const [siglas, setSiglas] = React.useState<any[]>([]);
    const [authors, setAuthors] = React.useState<any[]>([]);
    const [status, setStatus] = React.useState<any[]>([]);
    const [commissions, setCommissions] = React.useState<any[]>([]);
    const [selectedSiglas, setSelectedSiglas] = React.useState<any[]>(homefilters.siglas || []);
    const [selectedOrigins, setSelectedOrigins] = React.useState<any[]>(homefilters.origins || []);
    const [withInteractions, setWithInteractions] = React.useState<boolean>(!!homefilters.withInteractions);
    const [selectedAuthors, setSelectedAuthors] = React.useState<any[]>(homefilters.authors || []);
    const [selectedStatus, setSelectedStatus] = React.useState<any[]>(homefilters.status || []);
    const [selectedPositions, setSelectedPositions] = React.useState<any[]>(homefilters.positions || []);
    const [selectedPriorities, setSelectedPriorities] = React.useState<any[]>(homefilters.priorities || []);
    const [selectedCommissions, setSelectedCommissions] = React.useState<any[]>([]);
    const [keywords, setKeywords] = React.useState<boolean>(!!homefilters.keywords);
    const [keywordInput, setKeywordInput] = React.useState<string>("");
    const [otherKeywords, setOtherKeywords] = React.useState<string[]>(homefilters.otherKeywords ?? []);
    const [selectedTags, setSelectedTags] = React.useState<string[]>(homefilters.tags ?? []);
    const [calendarPeriod, setCalendarPeriod] = React.useState<string[]>([
        homefilters["calendar[start]"],
        homefilters["calendar[finish]"],
    ].filter(nn => nn));
    const [tramitationPeriod, setTramitationPeriod] = React.useState<string[]>([
        homefilters["tramitation[start]"],
        homefilters["tramitation[finish]"],
    ].filter(nn => nn));
    const [createdPeriod, setCreatedPeriod] = React.useState<string[]>([
        homefilters["created[start]"],
        homefilters["created[finish]"],
    ].filter(nn => nn));
    const [filterOpen, setFilterOpen] = React.useState<boolean>(false);
    const [exportingData, setExportingData] = React.useState<boolean>(false);
    const [loadingFilterOptions, setLoadingFilterOptions] = React.useState<boolean>(false);
    const [filters, setFilters] = React.useState(homefilters);

    const clearFilters = () => {
        setWithInteractions(false);
        setKeywords(false);
        setCalendarPeriod([]);
        setTramitationPeriod([]);
        setCreatedPeriod([]);
        setSelectedSiglas([]);
        setSelectedAuthors([]);
        setSelectedCommissions([]);
        setOtherKeywords([]);
    }

    const keySearch = [
        `SIGLAS`,
        `${selectedSiglas.join("--")}`,
        `AUTHORS`,
        `${selectedAuthors.join("--")}`,
        `STATUS`,
        `${selectedStatus.join("--")}`,
        `POSITIONS`,
        `${selectedPositions.join("--")}`,
        `PRIORITIES`,
        `${selectedPriorities.join("--")}`,
        `ORIGINS`,
        `${selectedOrigins.join("--")}`,
        `${withInteractions ? 1 : 0 }`,
        `COMMISSIONS`,
        `${selectedCommissions.join("--")}`,
        `CALENDAR`,
        calendarPeriod.join("--"),
        `TRAMITATION`,
        tramitationPeriod.join("--"),
        `CREATED`,
        createdPeriod.join("--"),
        `KEYWORDS`,
        `${keywords ? 1 : 0 }`,
        `OTHERKEYWORDS`,
        `${otherKeywords.join("--")}`,
        `TAGS`,
        `${selectedTags.join("--")}`,
        `KEYSEARCH`,
    ].join(";")


    const loadThemes = () => {
        const p = page[keySearch] ? page[keySearch] : 0;
        const ksPage = `${keySearch};${p}`
        if(!ending[keySearch]){
            setLoading(l => ({...l, [ksPage]: true}));
            setLoadingPage(l => ({...l, [keySearch]: true}));

            GET_ALL_THEMES({
                page: p,
                ...filters
            })
            .then((data) => {
                setData(d => ({ 
                    ...d, 
                    [keySearch]: groupBy([
                        ...((d && d[keySearch]) ? d[keySearch] : []),
                        ...data
                    ], item => item.id).map(g => g[1][0])
                }));
                setLoading(l => ({...l, [ksPage]: false}));
                setLoadingPage(l => ({...l, [keySearch]: false}));
                if(data.length === 0) setEnding(e => ({...e, [keySearch]: true}));
            })
            .catch(err => {
                setLoading(l => ({...l, [ksPage]: false}));
                setLoadingPage(l => ({...l, [keySearch]: false}));
                showNotification({title: "Ops.", message: err.message});
            })
        }
    }

    const exportData = async () => {
        setFilterOpen(false);
        setExportingData(true);
        try{
            let items = [], res = [];
            let page = 0;
            do{
                if(page > 30) throw new Error("O filtro selecionado está muito amplo");
                const data = await GET_ALL_THEMES({ page, ...filters });
                res = data;
                items = items.concat(data);
                page += 1;
            }while(res.length > 0);

            let arr = [['Projeto', 'Casa', 'Posicionamento', 'Prioridade', 'Autores']];
            for(let item of items){
                arr.push([
                    item.title, (item.origin ?? "").toUpperCase(), 
                    {
                        'favorable': "Favorável",
                        'favorable-res': "Favorável - com ressalvas",
                        'neutral': "Neutro",
                        'unfavorable-res': "Contra - com ressalvas",
                        'unfavorable': "Contra",
                    }[item.favorable] ?? "",
                    {
                        'very-high': "Prioridade - Muito alta",
                        'high': "Prioridade - Alta",
                        'medium': "Prioridade - Média",
                        'low': "Prioridade - Baixa",
                        'very-low': "Prioridade - Muito baixa",
                    }[item.priority] ??  "",
                    item.authors.map(a => `${a.name ?? ""}`).filter(nn => nn).join(", ")
                ]);
            }

            let csvText = arr.map(line => line.map(k => `"${k}"`).join(",")).join("\n");

            const byteCharacters = Buffer.from(csvText, "utf-8");
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) { byteNumbers[i] = byteCharacters[i]; }
            const byteArray = new Uint8Array(byteNumbers);
        
            const blob = new Blob([byteArray], { type: "application/csv" });
        
            const url = URL.createObjectURL(blob);;
            const a = document.createElement('a');
            a.href = url;
            a.download = `DMOC_Exportacao_de_Dados.csv`;
            a.click();
            URL.revokeObjectURL(url);
        }catch(err){
            showNotification({ message: err.message, color: 'red' })
        }finally{
            setExportingData(false);
        }
    }
    
    const themesItems = data[keySearch] || [];
    React.useEffect(() => {
        if(siglas.length === 0 || authors.length === 0 || commissions.length === 0 || status.length === 0){
            setLoadingFilterOptions(true);
            GET_FILTERS_OPTIONS()
            .then(({siglas, authors, commissions, status}) => {
                setLoadingFilterOptions(false);
                setSiglas(siglas || []);
                setAuthors(authors || []);
                setStatus(status || []);
                setCommissions(commissions || []);
            })
            .catch(err => {
                setLoadingFilterOptions(false);
            })
        }
    }, [filterOpen, siglas, authors, commissions])

    React.useEffect(() => { loadThemes() }, [page, ending, filters]);

    React.useEffect(() => {
        let css = {};
        for(let key in (homefiltersLS ? JSON.parse(homefiltersLS) : {})){
            if(key.startsWith("commissions[")){
                const split = key.split("[")
                const index = parseInt(split[1].split("]")[0]);
                const target = split[2].split("]")[0];
                css[`${index}`] = {...css[`${index}`], [`${target}`]: homefilters[key]}
            }
        }
        const items = [];
        for(let key in css){ items.push(`${css[key].origin};${css[key].id};${css[key].name}`); }
        setSelectedCommissions(items);
    }, [homefiltersLS]);
    
    React.useEffect(() => {
        localStorage.setItem("@dmoc/homeFilters", JSON.stringify(filters));
    }, [filters]);
    
    React.useEffect(() => {
        let commissionsParams = {};
        selectedCommissions.forEach((c, index) => {
            const splited = c.split(";");
            commissionsParams[`commissions[${index}][origin]`] = splited[0];
            commissionsParams[`commissions[${index}][id]`] = splited[1];
            commissionsParams[`commissions[${index}][name]`] = splited[2];
        })
        setFilters({
            siglas: selectedSiglas,
            withInteractions,
            keywords,
            authors: selectedAuthors,
            status: selectedStatus,
            positions: selectedPositions,
            priorities: selectedPriorities,
            origins: selectedOrigins,
            otherKeywords,
            tags: selectedTags,
            ...commissionsParams,
            "calendar[start]": calendarPeriod[0],
            "calendar[finish]": calendarPeriod[1],
            "created[start]": createdPeriod[0],
            "created[finish]": createdPeriod[1],
            "tramitation[start]": tramitationPeriod[0],
            "tramitation[finish]": tramitationPeriod[1],
        })
    }, [selectedSiglas, selectedTags, otherKeywords, withInteractions, keywords, selectedStatus, selectedPositions, selectedOrigins, selectedPriorities, selectedAuthors, selectedCommissions, calendarPeriod, createdPeriod, tramitationPeriod]);
    
    // React.useEffect(() => {
    //     if(macroFilter === '1'){
    //         setKeywords(false);
    //         setWithInteractions(false);
    //     }
    //     if(macroFilter === '2'){
    //         setKeywords(true);
    //         setWithInteractions(true);
    //     }
    // }, [macroFilter])

    return <div>
        <LoadingOverlay visible={exportingData} style={{position: 'fixed'}} />
        <Grid>
            <Grid.Col md={7} sm={12}>
                {/* <Tabs ml="md" mr="md" value={macroFilter} onTabChange={setMacroFilter}>
                    <Tabs.List>
                        <Tabs.Tab value='1'>Todas Pautas</Tabs.Tab>
                        <Tabs.Tab value='2'>Meu Interesse</Tabs.Tab>
                    </Tabs.List>
                </Tabs> */}
                <Grid p="md" style={{textAlign: 'right'}}>
                    <Grid.Col md={6} sm={12}>
                        <Menu>
                            <Menu.Target>
                                <Button 
                                    fullWidth
                                    variant="outline"
                                    color={createdPeriod.length > 0 ? "green" : "gray"}
                                    leftIcon={<FaPlusCircle />}
                                >{
                                    createdPeriod.length > 0
                                    ? createdPeriod.map(cp => moment(cp).format("DD/MM/YYYY")).join(" à ")
                                    : 'Apresentação'
                                }</Button>
                            </Menu.Target>
                            <Menu.Dropdown>
                                <Menu.Label>Apresentação</Menu.Label>
                                <Menu.Item icon={<FaPlusCircle color="gray" />} onClick={() => {
                                    setCreatedPeriod([ moment().startOf("week").format("YYYY-MM-DD"), moment().endOf("week").format("YYYY-MM-DD") ]);
                                }}>Essa semana</Menu.Item>
                                <Menu.Item icon={<FaPlusCircle color="gray" />} onClick={() => {
                                    setCreatedPeriod([ moment().subtract(1, "week").startOf("week").format("YYYY-MM-DD"), moment().subtract(1, "week").endOf("week").format("YYYY-MM-DD") ]);
                                }}>Semana passada</Menu.Item>
                                <Menu.Item icon={<FaPlusCircle color="gray" />} onClick={() => {
                                    setCreatedPeriod([ moment().startOf("month").format("YYYY-MM-DD"), moment().endOf("month").format("YYYY-MM-DD") ]);
                                }}>Esse mês</Menu.Item>
                                <Menu.Item icon={<FaPlusCircle color="gray" />} onClick={() => {
                                    setCreatedPeriod([ moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"), moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD") ]);
                                }}>Mês passado</Menu.Item>
                                {createdPeriod.length > 0 && <Menu.Item icon={<FaAsterisk color="gray" />} onClick={() => {
                                    setCreatedPeriod([]);
                                }}>Limpar Filtro</Menu.Item>}
                            </Menu.Dropdown>
                        </Menu>
                    </Grid.Col>
                    <Grid.Col md={6} sm={12}>
                        <Menu>
                            <Menu.Target>
                                <Button 
                                    fullWidth
                                    variant="outline"
                                    color={calendarPeriod.length > 0 ? "blue" : "gray"}
                                    leftIcon={<FaCalendar />}
                                >{
                                    calendarPeriod.length > 0
                                    ? calendarPeriod.map(cp => moment(cp).format("DD/MM/YYYY")).join(" à ")
                                    : 'Agenda'
                                }</Button>
                            </Menu.Target>
                            <Menu.Dropdown>
                                <Menu.Label>Agenda</Menu.Label>
                                <Menu.Item icon={<FaCalendar color="gray" />} onClick={() => {
                                    setCalendarPeriod([ moment().startOf("week").format("YYYY-MM-DD"), moment().endOf("week").format("YYYY-MM-DD") ]);
                                }}>Essa semana</Menu.Item>
                                <Menu.Item icon={<FaCalendar color="gray" />} onClick={() => {
                                    setCalendarPeriod([ moment().subtract(1, "week").startOf("week").format("YYYY-MM-DD"), moment().subtract(1, "week").endOf("week").format("YYYY-MM-DD") ]);
                                }}>Semana passada</Menu.Item>
                                <Menu.Item icon={<FaCalendar color="gray" />} onClick={() => {
                                    setCalendarPeriod([ moment().startOf("month").format("YYYY-MM-DD"), moment().endOf("month").format("YYYY-MM-DD") ]);
                                }}>Esse mês</Menu.Item>
                                <Menu.Item icon={<FaCalendar color="gray" />} onClick={() => {
                                    setCalendarPeriod([ moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"), moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD") ]);
                                }}>Mês passado</Menu.Item>
                                {calendarPeriod.length > 0 && <Menu.Item icon={<FaAsterisk color="gray" />} onClick={() => {
                                    setCalendarPeriod([]);
                                }}>Limpar Filtro</Menu.Item>}
                            </Menu.Dropdown>
                        </Menu>
                    </Grid.Col>
                    <Grid.Col md={6} sm={12}>
                        <Menu>
                            <Menu.Target>
                                <Button 
                                    fullWidth
                                    variant="outline"
                                    color={tramitationPeriod.length > 0 ? "blue" : "gray"}
                                    leftIcon={<FaBell />}
                                >{
                                    tramitationPeriod.length > 0
                                    ? tramitationPeriod.map(cp => moment(cp).format("DD/MM/YYYY")).join(" à ")
                                    : 'Tramitação'
                                }</Button>
                            </Menu.Target>
                            <Menu.Dropdown>
                                <Menu.Label>Tramitação</Menu.Label>
                                <Menu.Item icon={<FaBell color="gray" />} onClick={() => {
                                    setTramitationPeriod([ moment().startOf("week").format("YYYY-MM-DD"), moment().endOf("week").format("YYYY-MM-DD") ]);
                                }}>Essa semana</Menu.Item>
                                <Menu.Item icon={<FaBell color="gray" />} onClick={() => {
                                    setTramitationPeriod([ moment().subtract(1, "week").startOf("week").format("YYYY-MM-DD"), moment().subtract(1, "week").endOf("week").format("YYYY-MM-DD") ]);
                                }}>Semana passada</Menu.Item>
                                <Menu.Item icon={<FaBell color="gray" />} onClick={() => {
                                    setTramitationPeriod([ moment().startOf("month").format("YYYY-MM-DD"), moment().endOf("month").format("YYYY-MM-DD") ]);
                                }}>Esse mês</Menu.Item>
                                <Menu.Item icon={<FaBell color="gray" />} onClick={() => {
                                    setTramitationPeriod([ moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"), moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD") ]);
                                }}>Mês passado</Menu.Item>
                                {tramitationPeriod.length > 0 && <Menu.Item icon={<FaAsterisk color="gray" />} onClick={() => {
                                    setTramitationPeriod([]);
                                }}>Limpar Filtro</Menu.Item>}
                            </Menu.Dropdown>
                        </Menu>
                    </Grid.Col>
                    <Grid.Col md={6} sm={12}>
                        <Button
                            fullWidth
                            color="gray"
                            leftIcon={<FaEllipsisV />}
                            variant={"outline"}
                            onClick={() => setFilterOpen(fo => !fo)}
                        >Outros</Button>
                    </Grid.Col>
                    <Grid.Col lg={12}></Grid.Col>
                    <Grid.Col md={5} sm={12}>
                        <Button
                            fullWidth
                            color={withInteractions ? "green" : "gray"}
                            leftIcon={withInteractions ? <FaCheck /> : undefined}
                            variant={withInteractions ? "filled" : "outline"}
                            onClick={() => setWithInteractions(fo => !fo)}
                        >Acompanhando</Button>
                    </Grid.Col>
                    <Grid.Col md={5} sm={12}>
                        <Button
                            fullWidth
                            color={keywords ? "green" : "gray"}
                            leftIcon={keywords ? <FaCheck /> : undefined}
                            variant={keywords ? "filled" : "outline"}
                            onClick={() => setKeywords(fo => !fo)}
                        >Palavras-chaves</Button>
                    </Grid.Col>
                    <Grid.Col md={2} sm={12}>
                        <Button
                            fullWidth
                            color="gray"
                            variant="outline"
                            onClick={() => setFilterOpen(fo => !fo)}
                        ><FaEllipsisV /></Button>
                    </Grid.Col>
                    <Grid.Col md={12} sm={12}>
                        <Group position='right'>
                        {selectedSiglas.map(item => <Badge color="blue" ml="xs" mb="xs"
                            rightSection={<ActionIcon onClick={() => setSelectedSiglas(ss => ss.filter(i => i!==item))} variant="light"><FaMinusSquare/></ActionIcon>}
                        >{item}</Badge>)}
                        </Group>
                        <Group position='right'>
                        {selectedAuthors.map(item => <Badge color="yellow" ml="xs" mb="xs"
                            rightSection={<ActionIcon onClick={() => setSelectedAuthors(ss => ss.filter(i => i!==item))} variant="light"><FaMinusSquare/></ActionIcon>}
                        >{item}</Badge>)}
                        </Group>
                        <Group position='right'>
                        {selectedStatus.map(item => <Badge color="cyan" ml="xs" mb="xs"
                            rightSection={<ActionIcon onClick={() => setSelectedStatus(ss => ss.filter(i => i!==item))} variant="light"><FaMinusSquare/></ActionIcon>}
                        >{item}</Badge>)}
                        </Group>
                        <Group position='right'>
                        {selectedPositions.map(item => <Badge color="indigo" ml="xs" mb="xs"
                            rightSection={<ActionIcon onClick={() => setSelectedPositions(ss => ss.filter(i => i!==item))} variant="light"><FaMinusSquare/></ActionIcon>}
                        >{item === "none" ? "Sem posicionamento" : item}</Badge>)}
                        </Group>
                        <Group position='right'>
                        {selectedPriorities.map(item => <Badge color="grape" ml="xs" mb="xs"
                            rightSection={<ActionIcon onClick={() => setSelectedPriorities(ss => ss.filter(i => i!==item))} variant="light"><FaMinusSquare/></ActionIcon>}
                        >{item === "none" ? "Sem prioridade" : item}</Badge>)}
                        </Group>
                        <Group position='right'>
                        {selectedCommissions.map(item => <Badge color="green" ml="xs" mb="xs"
                            rightSection={<ActionIcon onClick={() => setSelectedCommissions(ss => ss.filter(i => i!==item))} variant="light"><FaMinusSquare/></ActionIcon>}
                            >{item.split(";")[2]}</Badge>)}
                        </Group>
                        <Group position='right'>
                        {(selectedTags || []).map(c => <Badge
                            color="yellow"
                            mr="sm"
                            mt="sm"
                            size='lg'
                            rightSection={<ActionIcon onClick={() => setSelectedTags(k => k.filter(kk => kk !== c))} variant="light"><FaMinusSquare/></ActionIcon>}
                        >{c}</Badge>)}
                        </Group>
                        <Group position='right'>
                        {(otherKeywords || []).map(c => <Badge
                            color="purple"
                            mr="sm"
                            mt="sm"
                            size='lg'
                            rightSection={<ActionIcon onClick={() => setOtherKeywords(k => k.filter(kk => kk !== c))} variant="light"><FaMinusSquare/></ActionIcon>}
                        >{c}</Badge>)}
                        </Group>
                    </Grid.Col>
                </Grid>
                <div>
                    <InfiniteLoading
                        identifier={keySearch}
                        setPage={ps => setPage(p => ({...p, [keySearch]: ps}))}
                        items={themesItems}
                        render={(item) => <ThemePaper theme={item} />}
                    />

                    {!loadingPage[keySearch] && themesItems.length === 0 && <div style={{textAlign: 'center'}}>
                        <Text color="gray" mt="lg">Nenhuma pauta para o filtro selecionado</Text>
                        <Button color="blue" mt="lg" onClick={clearFilters}>Ver todas</Button>
                    </div>}
                    {loadingPage[keySearch] && <div style={{textAlign: 'center'}}><Loader /></div>}
                </div>
            </Grid.Col>
            <Grid.Col md={1} sm={12}></Grid.Col>
            <Grid.Col md={4} sm={12}>
                
            </Grid.Col>
        </Grid>
        
        <Modal
            opened={filterOpen}
            onClose={() => setFilterOpen(false)}
            size="lg"
            title="Filtrar Pautas"
        >

            <Paper p="md">
                <Checkbox
                    onChange={e => setWithInteractions(e.target.checked)}
                    checked={withInteractions}
                    label="Pautas que estou acompanhando"
                />
            </Paper>
            
            <Paper p="md">
                <Checkbox
                    onChange={e => setKeywords(e.target.checked)}
                    checked={keywords}
                    label="Baseado em minhas palavras-chave"
                />
            </Paper>
            
            <Paper p="md">
                <InputField
                    type={InputFieldTypes.DATERANGE}
                    value={tramitationPeriod.map(cp => moment(cp, "YYYY-MM-DD").toDate())}
                    onChange={({period}) => { setTramitationPeriod(period.filter(p => moment(p).isValid()).map(p => moment(p).format("YYYY-MM-DD"))) }}
                    name="period"
                    title="Tramitação"
                    clearable
                />
            </Paper>
            
            <Paper p="md">
                <InputField
                    type={InputFieldTypes.DATERANGE}
                    value={createdPeriod.map(cp => moment(cp, "YYYY-MM-DD").toDate())}
                    onChange={({period}) => { setCreatedPeriod(period.filter(p => moment(p).isValid()).map(p => moment(p).format("YYYY-MM-DD"))) }}
                    name="period"
                    title="Data da Apresentação"
                    clearable
                />
            </Paper>

            <Paper p="md">
                <InputField
                    type={InputFieldTypes.DATERANGE}
                    value={calendarPeriod.map(cp => moment(cp, "YYYY-MM-DD").toDate())}
                    onChange={({period}) => { setCalendarPeriod(period.filter(p => moment(p).isValid()).map(p => moment(p).format("YYYY-MM-DD"))) }}
                    name="period"
                    title="Agenda"
                    clearable
                />
            </Paper>

            <Paper p="md">
                <InputField
                    type={InputFieldTypes.SELECT}
                    options={(userData?.company?.tags ?? []).map(tag => ({ value: tag, label: tag?.toUpperCase() }))}
                    value={selectedTags}
                    onChange={({tags}) => { setSelectedTags(tags) }}
                    name="tags"
                    title="Tags"
                    multiple
                    clearable
                />
            </Paper>

            <Paper p="md">
                <form onSubmit={(e) => {
                    e.preventDefault()
                    if((keywordInput ?? "").length > 2){
                        setOtherKeywords(k => [...k, keywordInput]);
                        setKeywordInput("");
                    }
                }}>
                    <Input.Wrapper
                        id="keyword-input"
                        label="Palavras chaves"
                        >
                        <Input
                            id="keyword-input"
                            placeholder="Palavra-chave"
                            value={keywordInput}
                            onChange={e => setKeywordInput(e.target.value)}
                            rightSection={
                                <ActionIcon type='submit' variant='light'>
                                    <FaPaperPlane />
                                </ActionIcon>
                            }
                        />
                    </Input.Wrapper>
                </form>

                {(otherKeywords || []).map(c => <Badge
                    color="yellow"
                    mr="sm"
                    mt="sm"
                    size='lg'
                    rightSection={<ActionIcon onClick={() => setOtherKeywords(k => k.filter(kk => kk !== c))} variant="light"><FaMinusSquare/></ActionIcon>}
                >{c}</Badge>)}
            </Paper>
            
            <Paper p="md">
                <MultiSelect
                    searchable
                    data={[
                        {value: 'camara', label: "Câmara dos Deputados"},
                        {value: 'senado', label: "Senado Federal"},
                    ]}
                    value={selectedOrigins}
                    onChange={setSelectedOrigins}
                    label="Casa"
                    placeholder="Selecione"
                    clearable
                />
            </Paper>

            <Paper p="md">
                <MultiSelect
                    searchable
                    data={[
                        {value: 'favorable', label: "Favorável"},
                        {value: 'favorable-res', label: "Favorável com ressalvas"},
                        {value: 'neutral', label: "Neutro"},
                        {value: 'unfavorable', label: "Contra"},
                        {value: 'unfavorable-res', label: "Contra com ressalvas"},
                        {value: 'none', label: "Sem posicionamento"},
                    ]}
                    value={selectedPositions}
                    onChange={setSelectedPositions}
                    label="Posicionamento"
                    placeholder="Selecione"
                    clearable
                />
            </Paper>
            
            <Paper p="md">
                <MultiSelect
                    searchable
                    data={[
                        {value: "very-high", label: "Muito alta"},
                        {value: "high", label: "Alta"},
                        {value: "medium", label: "Média"},
                        {value: "low", label: "Baixa"},
                        {value: "very-low", label: "Muito baixa"},
                        {value: "none", label: "Sem prioridade"},
                    ]}
                    value={selectedPriorities}
                    onChange={setSelectedPriorities}
                    label="Prioridade"
                    placeholder="Selecione"
                    clearable
                />
            </Paper>
            
            <Paper p="md">
                <MultiSelect
                    icon={loadingFilterOptions ? <Loader size="xs" ml="xs" /> : null}
                    searchable
                    data={siglas.map(({sigla}) => ({label: sigla, value: sigla}))}
                    value={selectedSiglas}
                    onChange={setSelectedSiglas}
                    label="Tipo de pauta"
                    placeholder="Selecione"
                    clearable
                />
            </Paper>

            <Paper p="md">
                <MultiSelect
                    icon={loadingFilterOptions ? <Loader size="xs" ml="xs" /> : null}
                    searchable
                    data={authors.map(({author}) => ({label: author, value: author}))}
                    value={selectedAuthors}
                    onChange={setSelectedAuthors}
                    label="Autor da pauta"
                    placeholder="Selecione"
                    clearable
                />
            </Paper>

            <Paper p="md">
                <MultiSelect
                    icon={loadingFilterOptions ? <Loader size="xs" ml="xs" /> : null}
                    searchable
                    data={status.map(({status}) => ({label: status, value: status}))}
                    value={selectedStatus}
                    onChange={setSelectedStatus}
                    label="Status da pauta"
                    placeholder="Selecione"
                    clearable
                />
            </Paper>

            <Paper p="md">
                <MultiSelect
                    icon={loadingFilterOptions ? <Loader size="xs" ml="xs" /> : null}
                    searchable
                    data={commissions.map(({title, id, origin}) => ({label: title, group: origin === "senado" ? "Senado Federal" : "Câmara dos Deputados" , value: `${origin};${id};${title}`}))}
                    value={selectedCommissions}
                    onChange={setSelectedCommissions}
                    label="Comissão atual"
                    placeholder="Selecione"
                    clearable
                />
            </Paper>

            <Group position="right">
                <Button color="blue" variant='light' onClick={exportData}>Exportar</Button>
                <Button color="blue" onClick={() => setFilterOpen(false)}>Filtrar</Button>
            </Group>
        </Modal>
    </div>
}
